// @ts-nocheck

/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@kubb/plugin-client/clients/axios";
import type { GetDailyStatusTarotDailyStatusGetQueryResponse } from "../models/tarotController/GetDailyStatusTarotDailyStatusGet.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@kubb/plugin-client/clients/axios";

function getGetDailyStatusTarotDailyStatusGetUrl() {
  const res = { method: "GET", url: `/tarot/daily_status` as const };
  return res;
}

/**
 * @summary Get Daily Status
 * {@link /tarot/daily_status}
 */
export async function getDailyStatusTarotDailyStatusGet(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetDailyStatusTarotDailyStatusGetQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: getGetDailyStatusTarotDailyStatusGetUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
